<div class="bulb-resume-user-info-container">
  <div class="bulb-user-info-details">
    <div class="bulb-resume-user-name">
      <div class="bulb-resume-avatar-img-container" data-obsvr-fade="data-obsvr-fade">
        <bulb-user-avatar *ngIf="!profileImage" [displayProps]="avatarDisplayProps"></bulb-user-avatar>
        <bulb-image *ngIf="profileImage" [creditType]="creditType" [imageAsset]="profileImage" (change)="updateProfileImage()">
        </bulb-image>
      </div>
      <h3>{{ resume.fullName }}</h3>
      <hr class="bulb-resume-hr">
    </div>
    <div class="resume-contact-details-wrapper">
      <div *ngIf="resume.emailAddress" class="bulb-contact-details bulb-contact-info-email">
        <div *ngIf="resumeService.getIsOwner(resume); else clickableEmail">
          <div class="bulb-contact-icon-container">
            <i class="far fa-envelope" aria-hidden="true"></i>
          </div>
          <span class="bulb-contact-details-text"> {{resume.emailAddress}}</span>
        </div>
      </div>
      <div *ngIf="resume.phoneNumber" class="bulb-contact-details bulb-contact-info-phonenum">
        <div *ngIf="resumeService.getIsOwner(resume); else clickablePhoneNumber">
          <div class="bulb-contact-icon-container">
            <i class="fas fa-mobile-alt" aria-hidden="true"></i>
          </div>
          <span class="bulb-contact-details-text"> {{resume.phoneNumber}}</span>
        </div>
      </div>
      <div *ngIf="resume.location" class="bulb-contact-details bulb-contact-info-location">
        <div class="bulb-contact-icon-container">
          <i class="far fa-map-marker-alt" aria-hidden="true"></i>
        </div>
        <span class="bulb-contact-details-text"> {{resume.location}}</span>
      </div>
    </div>
  </div>
  <div class="resume-contact-button-wrapper">
    <aero-button *ngIf="canEdit" class="bulb-contact-detail-button" [aeroStyle]="buttonStyle" icon="fal fa-pencil fa-lg"
      [size]="buttonSize" (click)="openContactInfoModal()" label="{{ 'resume.contactInfo.label' | transloco }}">
    </aero-button>
    <hr class="bulb-resume-hr">
  </div>
  <div class="bulb-resume-social">
    <div *ngIf="resume.linkedin" class="bulb-resume-social-icons">
      <a target="_blank" [href]="resume.linkedin">
        <img [src]="'resources/images/bulb_resume_linkedin.svg' " />
      </a>
    </div>
    <div *ngIf="resume.facebook" class="bulb-resume-social-icons">
      <a target="_blank" [href]="resume.facebook">
        <img [src]="'resources/images/bulb_resume_facebook.svg' " />
      </a>
    </div>
    <div *ngIf="resume.instagram" class="bulb-resume-social-icons">
      <a target="_blank" [href]="resume.instagram">
        <img [src]="'resources/images/bulb_resume_instagram.svg' " />
      </a>
    </div>
    <!-- twitter|X -->
    <div *ngIf="resume.twitter" class="bulb-resume-social-icons">
      <a target="_blank" [href]="resume.twitter">
        <img [src]="'resources/images/social_x_black.svg' " />
      </a>
    </div>
    <div *ngIf="resume.website" class="bulb-resume-social-icons">
      <a target="_blank" [href]="resume.website">
        <img [src]="'resources/images/bulb_resume_website.svg' "
          alt="{{ 'resume.socialProfile.website' | transloco }}" />
      </a>
    </div>
  </div>
  <div class="resume-button-wrapper">
    <!-- Contact Info button in tab view -->
    <aero-button *ngIf="canEdit" [aeroStyle]="buttonStyle" icon="fal fa-pencil fa-lg" class="bulb-contact-tab-view-button"
      [size]="buttonSize" (click)="openContactInfoModal()" label="{{ 'resume.contactInfo.label' | transloco }}">
    </aero-button>
    <aero-button *ngIf="canEdit" [aeroStyle]="buttonStyle" icon="fas fa-users" class="bulb-social-profiles-button"
      [size]="buttonSize" (onClick)="openSocialProfileDialog(resume)" labelCode="resume_social_profile_label">
    </aero-button>
  </div>
  <hr class="bulb-resume-hr-tab">
</div>


<!--TEMPLATES-->
<ng-template #clickableEmail>
  <a href="{{'mailto:' + resume.emailAddress }}" target="_blank" class="bulb-contact-details-clickable">
    <div class="bulb-contact-icon-container">
      <i class="far fa-envelope" aria-hidden="true"></i>
    </div>
    <span class="bulb-contact-details-text"> {{resume.emailAddress}}</span>
  </a>
</ng-template>

<ng-template #clickablePhoneNumber>
  <a href="{{'tel:' + resume.phoneNumber }}" target="_blank" class="bulb-contact-details-clickable">
    <div class="bulb-contact-icon-container">
      <i class="fas fa-mobile-alt" aria-hidden="true"></i>
    </div>
    <span class="bulb-contact-details-text"> {{resume.phoneNumber}}</span>
  </a>
</ng-template>
